import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const IconContainer = styled.span<{ $color?: string }>`
  color: ${({ $color, theme }) => schemeColor($color, theme) ?? 'inherit'};
`;
